import * as manageProjectType from './tabManagerType'
import React from 'react'
import useAppFolderAndTabAction from '../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useFolderAndTabStore, { TabSelectedType } from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { DialogType } from '../../../../control/dialog/dialog'

const useTabManager = (props: manageProjectType.UseManageProject) => {
    const folderAndTabStore = useFolderAndTabStore()
    const { tabSelected, tabIndexSelected } = folderAndTabStore

    const appFolderAndTabAction = useAppFolderAndTabAction()

    // const [tabIndex, setTabIndex] = React.useState(0)
    const dialogRef = React.useRef<Record<string, Function>>()
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const handleChangeTab = (tabIndex: number, newTabSelected: TabSelectedType) => {
        if (tabSelected.id !== newTabSelected.id) {
            setNewTab(tabIndex, newTabSelected)
        }
    }
    const setNewTab = (tabIndex: number, newTabSelected: any) => {
        dialogRef.current?.closeDialog()
        // setTabIndex(tabIndex)
        appFolderAndTabAction.setSeletedTabIndex(tabIndex)
        appFolderAndTabAction.setSeletedTab(newTabSelected as { id: number; nameTH: string })
    }

    return { tabIndex: tabIndexSelected, configDialog, onChangeTab: handleChangeTab, onRefDialog }
}

export default useTabManager
